module.exports = __webpack_public_path__ + "img/diy-GdGkTbFh.a97fd05d.svg";